export const formioConfig = {
    // Placeholder to suppress warnings
    // TODO:  (e.g.: self-hosted https://github.com/formio/formio)
    appUrl: 'https://spvlxmsxqxcjjkd.form.io',
    apiUrl: 'https://api.form.io'
};
